module.exports = __webpack_public_path__ + "img/translator__en-ch.36b592a.svg";